import React from "react";
import PropTypes from "prop-types";
import chevron from "@learningblocks/exp-constants/lib/Images/chevron.svg";
import chevronDisabled from "@learningblocks/exp-constants/lib/Images/chevron-disabled.svg";
import { Image } from "@learningblocks/shared-components";
import { Button } from "../Button";

import style from "./style.module.scss";

export function VagueStepper(props) {
  const vagueLeftButtonText = "Less";
  const vagueRightButtonText = "More";

  const vagueIncrement = () => {
    props.onChange(props.currentValue + props.step);
  };
  const vagueDecrement = () => {
    props.onChange(props.currentValue - props.step);
  };

  const underflow = () => props.currentValue === props.min;
  const overflow = () => props.currentValue === props.max;

  const leftButtonNormal = () => (
    <>
      <Image className={style.stepperVague_chevronLeft} src={chevron} />
      <span>{vagueLeftButtonText}</span>
    </>
  );

  const leftButtonDisabled = () => (
    <>
      <Image className={style.stepperVague_chevronLeft} src={chevronDisabled} />
      <span>{vagueLeftButtonText}</span>
    </>
  );

  const rightButtonNormal = () => (
    <>
      <span>{vagueRightButtonText}</span>
      <Image className={style.stepperVague_chevronRight} src={chevron} />
    </>
  );

  const rightButtonDisabled = () => (
    <>
      <span>{vagueRightButtonText}</span>
      <Image
        className={style.stepperVague_chevronRight}
        src={chevronDisabled}
      />
    </>
  );

  return (
    <>
      <Button
        className={style.stepperVague}
        onClick={vagueDecrement}
        disabled={underflow()}
        normalicon={leftButtonNormal()}
        disabledicon={leftButtonDisabled()}
      />
      <Button
        className={style.stepperVague}
        onClick={vagueIncrement}
        disabled={overflow()}
        normalicon={rightButtonNormal()}
        disabledicon={rightButtonDisabled()}
      />
    </>
  );
}

VagueStepper.propTypes = {
  /**
   * lowest value possible
   */
  min: PropTypes.number,
  /**
   * highest value possible
   */
  max: PropTypes.number,
  /**
   * current value
   */
  currentValue: PropTypes.number,
  /**
   * increment/decremnet step
   */
  step: PropTypes.number,
};
